import { post } from "storefront/GrailedAPI/request";
import { Id } from "storefront/lib/Id";
import { SearchKey } from "storefront/Algolia/SearchKey";

// https://www.grailed.com/internal/api-docs#tag/createUsersAlgoliaRestrictedKeys
type Response = {
  data: {
    searchKey: string;
    expiresAt: string;
  };
};

const unpack = (res: Response): SearchKey => ({
  value: res.data.searchKey,
  expiresAt: new Date(res.data.expiresAt),
});

/**
 * @name GrailedAPI.v1.Users.Algolia.createRestrictedKey
 * @return {Promise<Response>} returns a promise that resolves to the new created user-restricted algolia key
 */

const createRestrictedKey = (userId: Id): Promise<SearchKey> =>
  post<Response>(`/api/users/${userId}/algolia/restricted_keys`).then(unpack);

export default createRestrictedKey;
